import React from 'react';
import { UI_STYLES } from "../../styles/uiStyles";

interface FormInputProps {
  id: string;
  label: string;
  type: 'text' | 'email' | 'date' | 'password' | 'number';
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
  autoComplete?: string;
  max?: string;
  className?: string;
  min?: number;
  maxNumber?: number;
  step?: number;
}

export const FormInput: React.FC<FormInputProps> = ({
  id,
  label,
  type,
  value,
  onChange,
  error,
  autoComplete = 'off',
  max,
  className = '',
  min,
  maxNumber,
  step
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    
    if (type === 'number') {
      // Разрешаем только цифры, точку, минус и пустую строку
      const numberRegex = /^-?\d*\.?\d*$/;
      if (inputValue === '' || numberRegex.test(inputValue)) {
        onChange(inputValue);
      }
    } else {
      onChange(inputValue);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (type === 'number') {
      // Разрешаем: цифры, точка, минус, backspace, delete, стрелки, tab, enter
      const allowedKeys = [
        'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
        'Tab', 'Enter', 'Home', 'End'
      ];
      
      const isNumber = /^\d$/.test(e.key);
      const isAllowedKey = allowedKeys.includes(e.key);
      const isMinus = e.key === '-' && e.currentTarget.selectionStart === 0;
      const isDot = e.key === '.' && !e.currentTarget.value.includes('.');
      
      if (!isNumber && !isAllowedKey && !isMinus && !isDot) {
        e.preventDefault();
      }
    }
  };

  return (
    <div className={className}>
      <label className="block text-white/80 mb-2 text-start text-sm" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        type={type === 'number' ? 'text' : type} // Используем text для лучшего контроля
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        className={`w-full bg-transparent border-b border-white/30 text-white py-0 px-1 focus:outline-none ${UI_STYLES.emeraldBorderColorFocus} transition ${type === 'date' ? 'date-input-ru' : ''}`}
        autoComplete={autoComplete}
        max={max}
        min={min}
        maxLength={maxNumber ? maxNumber.toString().length : undefined}
        step={step}
        inputMode={type === 'number' ? 'decimal' : undefined}
        lang={type === 'date' ? 'ru' : undefined}
        data-date-format={type === 'date' ? 'DD.MM.YYYY' : undefined}
      />
      <div className="text-red-400 text-xs text-start mt-0" style={{visibility: error ? 'visible' : 'hidden'}}>{error || 'error'}</div>
    </div>
  );
};

export default FormInput; 
